import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ScheduleTriggerFormComponent } from './scheduletrigger-form/scheduletrigger-form.component';
import { ScheduleTriggerComponent } from './scheduletrigger.component';
import { ScheduleTriggerRoutes } from './scheduletrigger.routing';

export function declaration() {
    return [ScheduleTriggerComponent, ScheduleTriggerFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ScheduleTriggerModule {
}

@NgModule({
    imports: [ScheduleTriggerModule, ScheduleTriggerRoutes],
    exports: [ScheduleTriggerModule]
})
export class ScheduleTriggerWithRouteModule {
}
